// extracted by mini-css-extract-plugin
module.exports = {"product-wrap":"style_product-wrap__5TteV","content":"style_content__1Pm73","left":"style_left__1pXz9","right":"style_right__3B2fY"};